// src/api.ts

const BASE_URL = 'https://personalfinanceacademy.net/finance-api';

export interface UnsubscribeOptions {
    reason: string;
}

export interface UnsubscribePayload {
    first_name: string;
    last_name: string;
    email: string;
    iban_last_5: string;
    is_unsubscribe: boolean;
    message: string;
    options: UnsubscribeOptions;
}

export async function unsubscribe(payload: UnsubscribePayload) {
    const res = await fetch(`${BASE_URL}/subscriptions/unsubscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    });
    if (!res.ok) {
        const error = await res.text();
        throw new Error(error || 'Request failed');
    }
    return res.json();
}
